import { isAppPortocar } from '@/index';
import logo from '@/assets/images/Logo_Footer.png';
import logoMin from '@/assets/images/Logo-UC-mobile.png';
import { useWindowSize } from '@/hooks';

export default function SystemLogo() {
  const { width } = useWindowSize();

  return width < 992 ? (
    <div style={{ height: 46 }}>
      <img
        src={isAppPortocar ? '/images/Logo_PortoCar_branca-icon.svg' : logoMin}
        alt="logo"
        style={{ width: '60px' }}
      />
    </div>
  ) : (
    <div style={{ height: 64 }}>
      <img
        src={isAppPortocar ? '/images/Logo_PortoCar_branca.svg' : logo}
        alt="logo"
        style={{ width: 150 }}
      />
    </div>
  );
}
